import { usePlanFeatureGate } from './use-plan-feature-gate';
import { Features } from '../constants/features';
/** @typedef {import('../prop-types/intl-types').MessageDescriptor} MessageDescriptor */

/**
 * Returns is the Pick Lists Customized feature enabled for the current seller.
 * @returns {{ isFeatureEnabled: boolean, disabledMessage?: MessageDescriptor, shouldHide?: boolean }}
 */
export const usePickListsCustomizedFeatureGate = () => usePlanFeatureGate(Features.PickListsCustomized);
